var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inline-flex justify-between items-center cursor-pointer outline-none font-main font-semibold leading-[1.22]",class:{ [_vm.getClasses]: true },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("prepend"),_vm._t("default"),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }